import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'loggin',
      component: (resolve) => require(['../views/loggin.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },

    },
    {
      path: '/register',
      name: 'register',
      component: (resolve) => require(['../views/register.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },

    },
    {
      path: '/activity-notice',
      name: 'activity',
      component: (resolve) => require(['../views/activity/activity-notice.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/activity-invite',
      name: 'activity',
      component: (resolve) => require(['../views/activity/activity-invite.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/activity-gift',
      name: 'activity',
      component: (resolve) => require(['../views/activity/activity-gift.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/spell-group',
      name: 'spell-group',
      component: (resolve) => require(['../views/activity/spell-group.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/invite-register',
      name: 'invite-register',
      component: (resolve) => require(['../views/activity/invite-register.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/code-revice',
      name: 'code-revice',
      component: (resolve) => require(['../views/activity/code-revice.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/partner-register',
      name: 'partner-register',
      component: (resolve) => require(['../views/activity/partner-register.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/novice-gift',
      name: 'novice-gift',
      component: (resolve) => require(['../views/activity/novice-gift.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/buy-novice',
      name: 'buy-novice',
      component: (resolve) => require(['../views/activity/buy-novice.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/activity-pay',
      name: 'buy-novice',
      component: (resolve) => require(['../views/activity/pay.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    {
      path: '/register',
      name: 'register',
      component: (resolve) => require(['../views/register.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },

    {
      path: '/user-community',
      name: 'user-community',
      component: (resolve) => require(['../views/activity/user-community.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    },
    // 兑换优惠券激活码
    {
      path: '/coupon-exchange',
      name: 'coupon-exchange',
      component: (resolve) => require(['../views/activity/coupon-exchange.vue'], resolve),
      hidden: true,
      meta: { requireAuth: false },
    }

    // {
    //     path: '/forgotpwd',
    //     name: 'forgotpwd',
    //     component: (resolve) => require(['../views/forgotpwd.vue'], resolve),
    //     hidden: true,
    //     meta: { requireAuth: false },
    // },
    // {
    //     path: '/index',
    //     name: '',
    //     component: (resolve) => require(['../views/index.vue'], resolve),
    //     hidden: true,
    //     children: [{
    //             path: '/',
    //             name: '设备列表',
    //             component: (resolve) => require(['../views/padList/padList.vue'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/order',
    //             name: '我的订单',
    //             component: (resolve) => require(['../views/order/my-order.vue'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/service',
    //             name: '扩展服务',
    //             component: (resolve) => require(['../views/service/service.vue'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/orderlist',
    //             name: '我的订单',
    //             component: (resolve) => require(['../views/order/orderList.vue'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/order_detil',
    //             name: '订单详情',
    //             component: (resolve) => require(['../views/order/order_detil.vue'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/goods',
    //             name: '购买/续费',
    //             component: (resolve) => require(['../views/goods/goods.vue'], resolve),
    //             hidden: true,
    //         }, {
    //             path: '/userdetil',
    //             name: '用户信息',
    //             component: (resolve) => require(['../views/user/userDetil'], resolve),
    //             hidden: true,
    //         }, {
    //             path: '/updatepwd',
    //             name: '修改密码',
    //             component: (resolve) => require(['../views/user/updatepwd'], resolve),
    //             hidden: true,
    //         },
    //         {
    //             path: '/buymogu',
    //             name: '购买设备',
    //             component: (resolve) => require(['../views/goods/buymogu'], resolve),
    //             hidden: true,
    //         },
            // ,{
            //     path: '/player',
            //     name: '播放器',
            //     component: (resolve) => require(['../views/player/index.vue'], resolve),
            //     hidden: true,
            // },
            ,{
                path: '/players',
                name: '播放器',
                component: (resolve) => require(['../views/players/index.vue'], resolve),
                hidden: true,
            }
    //     ]
    // },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js